import(/* webpackMode: "eager" */ "C:\\Users\\ricpe\\medfollow-1\\src\\app\\page.tsx");
